import React from 'react';

// import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import useStyles from './styles';

export default function CustomPaper({ children, ...props }) {
  const classes = useStyles(props);
  return (
    // <Grid container spacing={3}>
    // <Grid item xs={12}>
    // <React.Fragment>
    <Paper className={classes.paper}>
      {children}
    </Paper>
    // </React.Fragment>
    // </Grid>
    // </Grid>
  );
};
